/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FamilyPoolInvitationCreateRequest,
  FamilyPoolInvitationListResponse,
  FamilyPoolInvitationResponse,
  FamilyPoolInvitationUpdateRequest,
  FamilyPoolRelationshipListResponse,
  HTTPBadRequestError,
  HTTPForbiddenError,
  HTTPUnauthorizedError,
  HTTPValidationError,
  PooledLoyaltyAccountsResponse,
} from '../models/index';
import {
    FamilyPoolInvitationCreateRequestFromJSON,
    FamilyPoolInvitationCreateRequestToJSON,
    FamilyPoolInvitationListResponseFromJSON,
    FamilyPoolInvitationListResponseToJSON,
    FamilyPoolInvitationResponseFromJSON,
    FamilyPoolInvitationResponseToJSON,
    FamilyPoolInvitationUpdateRequestFromJSON,
    FamilyPoolInvitationUpdateRequestToJSON,
    FamilyPoolRelationshipListResponseFromJSON,
    FamilyPoolRelationshipListResponseToJSON,
    HTTPBadRequestErrorFromJSON,
    HTTPBadRequestErrorToJSON,
    HTTPForbiddenErrorFromJSON,
    HTTPForbiddenErrorToJSON,
    HTTPUnauthorizedErrorFromJSON,
    HTTPUnauthorizedErrorToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PooledLoyaltyAccountsResponseFromJSON,
    PooledLoyaltyAccountsResponseToJSON,
} from '../models/index';

export interface FamilyPoolInvitationsFamilyPoolInvitationIdDeleteRequest {
    familyPoolInvitationId: string;
}

export interface FamilyPoolInvitationsFamilyPoolInvitationIdPutRequest {
    familyPoolInvitationId: string;
    familyPoolInvitationUpdateRequest: FamilyPoolInvitationUpdateRequest;
}

export interface FamilyPoolInvitationsPostRequest {
    familyPoolInvitationCreateRequest: FamilyPoolInvitationCreateRequest;
}

export interface FamilyPoolRelationshipsFamilyPoolRelationshipIdDeleteRequest {
    familyPoolRelationshipId: string;
}

export interface V2UsersUserIdPooledLoyaltyAccountsGetRequest {
    userId: string;
    extended?: boolean;
}

/**
 * 
 */
export class FamilyPoolApi extends runtime.BaseAPI {

    /**
     * Revoke (inviter) or decline (invitee) a family pool invitation.
     */
    async familyPoolInvitationsFamilyPoolInvitationIdDeleteRaw(requestParameters: FamilyPoolInvitationsFamilyPoolInvitationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['familyPoolInvitationId'] == null) {
            throw new runtime.RequiredError(
                'familyPoolInvitationId',
                'Required parameter "familyPoolInvitationId" was null or undefined when calling familyPoolInvitationsFamilyPoolInvitationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/family_pool_invitations/{family_pool_invitation_id}`;
        urlPath = urlPath.replace(`{${"family_pool_invitation_id"}}`, encodeURIComponent(String(requestParameters['familyPoolInvitationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revoke (inviter) or decline (invitee) a family pool invitation.
     */
    async familyPoolInvitationsFamilyPoolInvitationIdDelete(requestParameters: FamilyPoolInvitationsFamilyPoolInvitationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.familyPoolInvitationsFamilyPoolInvitationIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Accept or decline a family pool invitation (invitee only).
     */
    async familyPoolInvitationsFamilyPoolInvitationIdPutRaw(requestParameters: FamilyPoolInvitationsFamilyPoolInvitationIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyPoolInvitationResponse>> {
        if (requestParameters['familyPoolInvitationId'] == null) {
            throw new runtime.RequiredError(
                'familyPoolInvitationId',
                'Required parameter "familyPoolInvitationId" was null or undefined when calling familyPoolInvitationsFamilyPoolInvitationIdPut().'
            );
        }

        if (requestParameters['familyPoolInvitationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'familyPoolInvitationUpdateRequest',
                'Required parameter "familyPoolInvitationUpdateRequest" was null or undefined when calling familyPoolInvitationsFamilyPoolInvitationIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/family_pool_invitations/{family_pool_invitation_id}`;
        urlPath = urlPath.replace(`{${"family_pool_invitation_id"}}`, encodeURIComponent(String(requestParameters['familyPoolInvitationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FamilyPoolInvitationUpdateRequestToJSON(requestParameters['familyPoolInvitationUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyPoolInvitationResponseFromJSON(jsonValue));
    }

    /**
     * Accept or decline a family pool invitation (invitee only).
     */
    async familyPoolInvitationsFamilyPoolInvitationIdPut(requestParameters: FamilyPoolInvitationsFamilyPoolInvitationIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyPoolInvitationResponse> {
        const response = await this.familyPoolInvitationsFamilyPoolInvitationIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List pending family pool invitations (sent and received).
     */
    async familyPoolInvitationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyPoolInvitationListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/family_pool_invitations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyPoolInvitationListResponseFromJSON(jsonValue));
    }

    /**
     * List pending family pool invitations (sent and received).
     */
    async familyPoolInvitationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyPoolInvitationListResponse> {
        const response = await this.familyPoolInvitationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Send a family pool invitation.
     */
    async familyPoolInvitationsPostRaw(requestParameters: FamilyPoolInvitationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyPoolInvitationResponse>> {
        if (requestParameters['familyPoolInvitationCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'familyPoolInvitationCreateRequest',
                'Required parameter "familyPoolInvitationCreateRequest" was null or undefined when calling familyPoolInvitationsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/family_pool_invitations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FamilyPoolInvitationCreateRequestToJSON(requestParameters['familyPoolInvitationCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyPoolInvitationResponseFromJSON(jsonValue));
    }

    /**
     * Send a family pool invitation.
     */
    async familyPoolInvitationsPost(requestParameters: FamilyPoolInvitationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyPoolInvitationResponse> {
        const response = await this.familyPoolInvitationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disconnect a family pool relationship (either side).
     */
    async familyPoolRelationshipsFamilyPoolRelationshipIdDeleteRaw(requestParameters: FamilyPoolRelationshipsFamilyPoolRelationshipIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['familyPoolRelationshipId'] == null) {
            throw new runtime.RequiredError(
                'familyPoolRelationshipId',
                'Required parameter "familyPoolRelationshipId" was null or undefined when calling familyPoolRelationshipsFamilyPoolRelationshipIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/family_pool_relationships/{family_pool_relationship_id}`;
        urlPath = urlPath.replace(`{${"family_pool_relationship_id"}}`, encodeURIComponent(String(requestParameters['familyPoolRelationshipId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Disconnect a family pool relationship (either side).
     */
    async familyPoolRelationshipsFamilyPoolRelationshipIdDelete(requestParameters: FamilyPoolRelationshipsFamilyPoolRelationshipIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.familyPoolRelationshipsFamilyPoolRelationshipIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * List active family pool members.
     */
    async familyPoolRelationshipsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyPoolRelationshipListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/family_pool_relationships`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyPoolRelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * List active family pool members.
     */
    async familyPoolRelationshipsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyPoolRelationshipListResponse> {
        const response = await this.familyPoolRelationshipsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read loyalty accounts shared with the given user via active family pool relationships. Each returned account is wrapped with attribution identifying the pooled peer who owns it. Does not include the user\'s own loyalty accounts.
     */
    async v2UsersUserIdPooledLoyaltyAccountsGetRaw(requestParameters: V2UsersUserIdPooledLoyaltyAccountsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PooledLoyaltyAccountsResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling v2UsersUserIdPooledLoyaltyAccountsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['extended'] != null) {
            queryParameters['extended'] = requestParameters['extended'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/users/{user_id}/pooled-loyalty-accounts`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PooledLoyaltyAccountsResponseFromJSON(jsonValue));
    }

    /**
     * Read loyalty accounts shared with the given user via active family pool relationships. Each returned account is wrapped with attribution identifying the pooled peer who owns it. Does not include the user\'s own loyalty accounts.
     */
    async v2UsersUserIdPooledLoyaltyAccountsGet(requestParameters: V2UsersUserIdPooledLoyaltyAccountsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PooledLoyaltyAccountsResponse> {
        const response = await this.v2UsersUserIdPooledLoyaltyAccountsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
